<script>
import VueHeroicons from '@iwavesmedia/vue-heroicons';

export default {
    extends: VueHeroicons,
};
</script>
